import { useQuery } from '@tanstack/react-query';
import { POST, POST_BRANCH } from '..';
import { serviceOptions } from '../../functions/serviceOption';

export const branchOptionQuery = (employeeId) =>
  useQuery({
    queryKey: ['branchOptionQuery', employeeId],
    queryFn: async () => {
      const response = await POST(POST_BRANCH(), { employeeId });
      return serviceOptions('BRANCH_OPTION', response.result.options);
    },
  });
